/**
 * Ryan O'Dowd
 * 2025-03-21
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
  };
};

export default getStyles;
